import { createFileRoute } from '@tanstack/react-router'
import { useSuspenseInfiniteQuery } from '@tanstack/react-query'
import { channelPostsInfiniteOptions } from '@/lib/queries/community'
import { ChannelFeed } from '@/components/community/channel-feed'

export const Route = createFileRoute('/_app/comunidade/$channel')({
  loader: async ({ context, params }) => {
    await context.queryClient.fetchInfiniteQuery(channelPostsInfiniteOptions(params.channel))
  },
  component: ChannelPage,
})

function ChannelPage() {
  const { channel } = Route.useParams()
  const query = useSuspenseInfiniteQuery(channelPostsInfiniteOptions(channel))

  const pages = query.data?.pages ?? []
  const channelData = (pages[0] as any)?.data?.channel
  const allPosts = pages.flatMap((page: any) => page?.data?.posts ?? [])

  return (
    <ChannelFeed
      channel={channelData}
      posts={allPosts}
      hasMore={query.hasNextPage}
      isFetchingMore={query.isFetchingNextPage}
      onLoadMore={() => query.fetchNextPage()}
    />
  )
}
